import { isIconColorKey, type IconColorKey } from '@littlebird/sdk';
import { type SkinTone } from 'frimousse';

const ICON_COLOR_STORAGE_KEY = 'littlebird:icon-picker:last-color';
const LEGACY_PROJECT_COLOR_STORAGE_KEY = 'littlebird:projects:last-icon-color';
const SKIN_TONE_STORAGE_KEY = 'littlebird:icon-picker:skin-tone';
const SKIN_TONES: SkinTone[] = [
  'none',
  'light',
  'medium-light',
  'medium',
  'medium-dark',
  'dark',
];

export function readLastIconColor(): IconColorKey | null {
  const stored =
    localStorage.getItem(ICON_COLOR_STORAGE_KEY) ??
    localStorage.getItem(LEGACY_PROJECT_COLOR_STORAGE_KEY);
  return isIconColorKey(stored) ? stored : null;
}

export function writeLastIconColor(color: IconColorKey | null): void {
  localStorage.removeItem(LEGACY_PROJECT_COLOR_STORAGE_KEY);
  if (color === null) {
    localStorage.removeItem(ICON_COLOR_STORAGE_KEY);
    return;
  }
  localStorage.setItem(ICON_COLOR_STORAGE_KEY, color);
}

export function readLastSkinTone(): SkinTone {
  const stored = localStorage.getItem(SKIN_TONE_STORAGE_KEY);
  return SKIN_TONES.includes(stored as SkinTone)
    ? (stored as SkinTone)
    : 'none';
}

export function writeLastSkinTone(skinTone: SkinTone): void {
  localStorage.setItem(SKIN_TONE_STORAGE_KEY, skinTone);
}
